import { call } from '../../../../stent/call';
export const makeRemoveItems = function(ctx) {
    const { changeItemQuantity  } = ctx;
    return function* removeItems(machine, payload) {
        try {
            const { lineItemKeys  } = payload;
            if (machine.state.contents == null) {
                throw new Error('Cart contents missing');
            }
            yield {
                name: 'Updating',
                error: null,
                contents: machine.state.contents
            };
            yield call(changeItemQuantity, {
                items: lineItemKeys.map((lineItemKey)=>{
                    return {
                        lineItemKey,
                        quantity: 0
                    };
                })
            });
            yield {
                name: 'Stale',
                error: null,
                contents: machine.state.contents
            };
            machine.refresh();
        } catch (err) {
            yield {
                error: err instanceof Error ? err : new Error('Unknown error [cdc8419e654547b5a21307e0ef1b0b67]'),
                name: 'Failure',
                contents: machine.state.contents
            };
        }
    };
};
